import { SearchItem, UrlItem } from 'respona_api/generated/search-content_pb';

export const SearchTypesEnum = {
  googleSearch: 'googleSearch',
  googleNews: 'googleNews',
  bingSearch: 'bingSearch',
  bingNews: 'bingNews',
  podcasts: 'podcasts',
  episodes: 'episodes',
};

export type SearchItemType = SearchItem.AsObject;

export type UrlItemType = UrlItem.AsObject;
